import {NEW_BANK_ACCOUNT} from '@advisor/util/constants';

export default class MoneyTransfer {
  constructor() {
    this.activeTab = null;
    this.brokerageAccounts = [];
    this.bankAccounts = [{id: NEW_BANK_ACCOUNT.ID, bankName: NEW_BANK_ACCOUNT.NAME}];
    this.iraConstraints = {
      contributionConstraints: null,
      distributionConstraints: null,
      retirementAccount: null,
    };
    this.transferFrequencies = [];
    this.transferDetails = null;
    this.apexLabels = [];
    this.transferTypes = null;
    this.transferStatus = null;
    this.reviewDetails = {
      // Initials for default Review
      brokerageAccount: {
        accountType: null,
        custodianAccountNumber: null,
        custodian: null,
      },
      bankAccount: {
        bankAccountType: null,
        bankName: null,
      },
      transferDetails: null,
    };
    this.transactionDetails = null;
    this.firstAvailableDate = null;
    this.disabledContinue = false;
    this.distributionReasonList = [];
  }
}
